(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('ActiveUsersCtrl', ActiveUsersCtrl);

  // @ngInject
  function ActiveUsersCtrl(storeKeys, filters, DateUtil, ConsumerChart, StandardReports,
                               Callout, ShopperReports, SectionConfig, UserCohort, ConsumerChartDisplay) {
    var vm = this;

    var detailLevel = filters.pathParams.detailLevel;

    vm.dateRange = {startDate: filters.queryParams.startDate, endDate: filters.queryParams.endDate};

    vm.transactionColorSwatch = StandardReports.getColorSwatches([
        ConsumerChartDisplay.Colors.ipRegistered.stroke,
        ConsumerChartDisplay.Colors.travellingRegistered.stroke,
        ConsumerChartDisplay.Colors.siteRegistered.stroke
    ]);

    var queryFilters = _.merge(filters.queryParams, {storeKey: storeKeys});
    vm.apiParams = { detailLevel: detailLevel, queryParams: queryFilters };

    vm.mauSection = Callout.labelValueConfig(SectionConfig.mau);
    vm.monthlyActiveUsersChartData = function(rawData) {
      return rawData;
    };

    vm.mauTFSection = Callout.tfUsersConfig(SectionConfig.mauTF);
    vm.tfMonthlyActiveUsersChartData = function(rawData) {
      return rawData;
    };

    vm.dauSection = Callout.labelValueConfig(SectionConfig.dau);
    vm.dailyActiveUsersChartData = function(rawData) {
      return rawData;
    };

    vm.dauTFSection = Callout.tfUsersConfig(SectionConfig.dauTF);
    vm.tfDailyActiveUsersChartData = function(rawData) {
      var allTimeTFUsers = ConsumerChart.getChartData(rawData.dateMetrics, {userCohort: 'TrueFitAllTime', isBot: false});
      var tfUsersTillEndDate = _.last(allTimeTFUsers);
      vm.alltimeTFUsers = tfUsersTillEndDate && tfUsersTillEndDate.value;

      return rawData;

    };

    vm.newUsersSection = Callout.tfUsersConfig(SectionConfig.newUsers);
    vm.newUsersChartData = function(rawData) {
      vm.newTFUsers = StandardReports.findInSummary(rawData.summary, 'TotalNewUserCounts', UserCohort.newTFUsers.value);
      return rawData;
    };

  }
  })();
